export const PHISHING = {
  SIMULATIONS: {
    TITLE: 'Campañas de Phishing',
    SIMULATIONS_SECTION: 'Campañas',
    RECENT_SIMULATIONS: 'Campañas recientes',
    NO_CAMPAIGNS: 'Aún no hay campañas',
    COLUMNS: {
      TARGETED: 'Objetivo',
      SENT: 'Enviados',
      VIEWED: 'Vistos',
      CLICKED: 'Clicados',
      CREDENTIALS: 'Credenciales',
      REPORTED: 'Reportados',
    },
    ICONS: {
      TARGETED_USERS: 'Usuarios objetivo',
      EMAILS_VIEWED_VS_DELIVERED: 'Correos vistos/entregados',
      DATE: 'Fecha',
      CREDENTIALS_ENTERED: 'Credenciales ingresadas',
    },
  },
  KPIS: {
    CAMPAIGNS_SENT: 'Campañas enviadas',
    EMPLOYEES_TARGETED: 'empleados objetivo',
    LINKS_CLICKED: 'Enlaces clickeados',
    LINKS_CLICKED_NOTE: 'En todas las campañas',
    CREDENTIALS_ENTERED: 'Credenciales ingresadas',
    CREDENTIALS_ENTERED_NOTE: 'Empleados que introdujeron sus credenciales',
    REPORTED: 'Reportado',
    REPORTED_NOTE: 'Empleados que reportaron el correo',
  },
  RISK: {
    TITLE: 'Perfil de riesgo',
    DESCRIPTION: 'Exposición humana al phishing.',
    SCORE_MAX: '/ 100',
    RISK_LOW: 'Bajo',
    RISK_MODERATE: 'Moderado',
    RISK_HIGH: 'Alto',
    RISK_EXPLANATION:
      'Media de las puntuaciones de riesgo de phishing de todos los empleados, en una escala de 0 a 100',
    OUTCOMES_TITLE: 'Resultados por empleado',
    TESTED: 'evaluados',
    ENTERED_CREDENTIALS: 'Introdujeron credenciales',
    REPEAT_CLICKERS: 'Reincidentes en clics',
    REPORTED_AT_LEAST_ONCE: 'Reportaron al menos una vez',
    NO_RESULTS: 'Aún no hay resultados por empleado',
  },
  TRENDS: {
    TITLE: 'Evolución de ejercicios',
    DESCRIPTION: 'Como proporción de los empleados objetivo.',
    LINKS_CLICKED: 'Enlaces Clickeados',
    CREDENTIALS_ENTERED: 'Credenciales Ingresadas',
    VIEWED: 'Correos Vistos',
    REPORTED: 'Reportado',
    EMPTY: 'Aún no hay campañas',
  },
  SIMULATION_DETAIL: {
    BREADCRUMB: {
      PEOPLE: 'Empleados',
      PHISHING_SIMULATIONS: 'Campañas de Phishing',
    },
    METRICS: {
      EMAIL_ENGAGEMENT: 'Interacción de correo',
      CAMPAIGN_REACH: 'Alcance e interacción de campaña',
      EMPLOYEES_TARGETED: 'Empleados objetivo',
      EMAILS_VIEWED_DELIVERED: 'Correos vistos/entregados',
      REPLIES: 'Respuestas',
      SECURITY_RESPONSE: 'Respuesta de seguridad',
      USER_BEHAVIOR: 'Comportamiento del usuario y conciencia de seguridad',
      LINKS_CLICKED: 'Enlaces clickeados',
      CREDENTIALS_ENTERED: 'Credenciales ingresadas',
      REPORTED: 'Reportado',
    },
    EMPLOYEE_RESULTS: {
      TITLE: 'Resultados de Empleados',
      SEARCH_PLACEHOLDER: 'Buscar empleados...',
      TABLE: {
        EMAIL: 'Correo',
        DELIVERY_STATUS: 'Estado de Entrega',
        VIEWED: 'Visto',
        REPLIED: 'Respondido',
        CLICKED: 'Clickeado',
        CREDENTIALS: 'Credenciales',
        REPORTED: 'Reportado',
      },
      STATUS: {
        DELIVERED: 'Entregado',
        BOUNCED: 'Rebotado',
        PENDING: 'Pendiente',
        UNKNOWN: 'Desconocido',
      },
      FILTERS: {
        ALL: 'Todos',
        VIEWED: 'Visto',
        REPLIED: 'Respondido',
        CLICKED: 'Clickeado',
        CREDENTIALS: 'Credenciales',
        REPORTED: 'Reportado',
      },
    },
    TEMPLATE_VIEWER: {
      TITLE: 'Plantillas de campaña',
      EMAIL_TEMPLATE: 'Ver plantilla de correo',
      LANDING_PAGE: 'Ver página de destino',
      EMAIL_TEMPLATE_TITLE: 'Plantilla de Correo',
      LANDING_PAGE_TITLE: 'Página de Destino',
      EMAIL_TEMPLATE_ALT: 'Plantilla de correo',
      LANDING_PAGE_ALT: 'Página de destino',
    },
  },
}
